const formInputs = {
  goals: [
    {
      name: "Long term career guidance",
      id: "longterm",
    },
    {
      name: "Quick coffee chat",
      id: "coffee",
    },
    {
      name: "Phone call",
      id: "call",
    },
  ],
  expertise: [
    {
      name: "Designer",
      id: "designer",
    },
    {
      name: "Product Manager",
      id: "pm",
    },
    {
      name: "Developer",
      id: "developer",
    },
  ],
  experience: [
    {
      name: "Early Career",
      id: "early",
    },
    {
      name: "Intermediate",
      id: "intermediate",
    },
    {
      name: "Senior",
      id: "senior",
    },
    {
      name: "Manager",
      id: "manager",
    },
  ],
  skills: [
    {
      name: "Figma",
      id: "figma",
    },
    {
      name: "Adobe",
      id: "adobexd",
    },
    {
      name: "HTML",
      id: "html",
    },
    {
      name: "TypeScript",
      id: "ts",
    },
    {
      name: "Scrum",
      id: "scrum",
    },
    {
      name: "Agile",
      id: "agile",
    },
    {
      name: "Content Writing",
      id: "content",
    },
    {
      name: "IA",
      id: "ia",
    },
    {
      name: "CSS",
      id: "css",
    },
    {
      name: "JavaScript",
      id: "js",
    },
    {
      name: "Quantitative Research",
      id: "qa",
    },
    {
      name: "SASS",
      id: "sass",
    },
  ],
  pronouns: [
    {
      name: "She/Her",
      id: "she"
    },
    {
      name: "He/Him",
      id: "he"
    },
    {
      name: "They/Them",
      id: "they",
    }
  ],
  bootStatus: [
    {
      name: "Yes",
      id: "yesboot",
    },
    {
      name: "No",
      id: "noboot",
    },
    {
      name: "Not Interested",
      id: "uninterested",
    },
  ],
  connection: [
    
      {
      name: "No preference",
      id: "unimportant",
    },
    {
      name: "Female",
      id: "female",
    },
    {
      name: "Male",
      id: "male",
    },
    {
      name: "LGBTQA+",
      id: "lgbtqa",
    },
    {
      name: "Person of color",
      id: "color",
    },
    
  ],
  mentorRoles: [
    {
      name: "Mentor",
      id: "mentor"
    },
    {
      name: "Mentee",
      id: "mentee"
    },
  ],
  intovertedness: [
    {
      name: "Introverted",
      id: "introverted"
    },
    {
      name: "Extroverted",
      id: "extroverted"
    },
    {
      name: "I'm not sure",
      id: "unsure"
    },
    {
      name: "It's not important",
      id: "none"
    },
  ],
  sportiness: [
    {
      name: "Watching or playing sports",
      id: "sports"
    },
    {
      name: "Getting lost in a book or film",
      id: "book"
    },
    {
      name: "Appreciating art and/or music",
      id: "music"
    },
    {
      name: "Being outside",
      id: "outside"
    },
    {
      name: "Spending time with family",
      id: "family"
    },
  ]

};

export default formInputs;
